import { OurObjectives } from "./OurObjectives";
export default OurObjectives;
